<div class="flex-col height100p">
    @if (invalidToken) {
    <div class="p-4 flex flex-col items-center text-center">
        <h2>Ungültiger Link</h2>
        <p class="mb-3">Der Link ist ungültig oder abgelaufen</p>
    </div>
    }
    @else {
    @if (def?.useSearchBar) {
    <sm-toolbar class="documents-quick-search-toolbar" [class.documents-toolbar-compact]="toolbarCompact">
        <input pInputText [(ngModel)]="input" />
        <p-button icon="fas fa-search" [label]="def.searchBarLabel" [pTooltip]="toolbarCompact ? def.searchBarLabel : null" (onClick)="searchDocuments()"></p-button>
    </sm-toolbar>
    }
    @if (def != null) {
    <sm-toolbar #documentsToolbar class="documents-toolbar" [class.documents-toolbar-compact]="toolbarCompact">
        <ng-content></ng-content>
        @if (documentTypeOptions.length > 1) {
        <span class="document-type-filter flex align-items-center">
            <span class="document-toolbar-label mr-2">{{app.t('documents.documentType')}}</span>
            <p-select class="width300" appendTo="body" [options]="documentTypeOptions" [(ngModel)]="defId" (onChange)="documentTypeChanged()"></p-select>
        </span>
        }
        <input pInputText class="documents-full-text-search width400" type="text" [placeholder]="app.t('documents.search')" [(ngModel)]="fullTextSearchTerm" (ngModelChange)="updateFilter()"
                />
        @if (def.canUpload) {
        <button pButton icon="fas fa-cloud-upload-alt" [label]="app.t('documents.uploadDocument')" [pTooltip]="toolbarCompact ? app.t('documents.uploadDocument') : null" [attr.aria-label]="app.t('documents.uploadDocument')" (click)="newDocument($event)"></button>
        }
        @if (def.hasDocuments && table?.rows?.length > 0) {
        <button pButton icon="fas fa-file-download" [label]="app.t('documents.downloadAll')" [pTooltip]="toolbarCompact ? app.t('documents.downloadAll') : null" [attr.aria-label]="app.t('documents.downloadAll')" (click)="downloadAll()"></button>
        }
        @if (table != null && def.allowExportTable) {
        <p-splitButton [label]="app.t('documents.exportAsCsv')" icon="fas fa-file-download" [model]="exportMenuItems" [pTooltip]="toolbarCompact ? app.t('documents.exportAsCsv') : null" (onClick)="exportCsv()"></p-splitButton>
        }
        @if (def.useSeenMarker && !def.seenMarkerImplicit) {
        <span class="toolbar-divider"></span>
        <p-checkbox class="mr-3" [appLabel]="app.t('documents.displaySeen')" [(ngModel)]="displaySeen" [binary]=true (ngModelChange)="updateFilter()"></p-checkbox>
        <button pButton icon="fas fa-eye" [label]="app.t('documents.markAllAsSeen')" [pTooltip]="toolbarCompact ? app.t('documents.markAllAsSeen') : null" [attr.aria-label]="app.t('documents.markAllAsSeen')" (click)="markAllAsSeen()"></button>
        }
        @if (searchFields.length > 0) {
        <span class="toolbar-divider"></span>
        @for (field of searchFields; track field) {
        <span class="document-search-field flex align-items-center">
            <span class="document-toolbar-label mr-2">{{field.title}}</span>
            <app-sm-form-field-internal [field]="field" fluentWidth="200px">
            </app-sm-form-field-internal>
        </span>
        }
        <button pButton icon="fas fa-filter" [label]="app.t('documents.filter')" [pTooltip]="toolbarCompact ? app.t('documents.filter') : null" [attr.aria-label]="app.t('documents.filter')" (click)="filterChanged()"></button>
        }
    </sm-toolbar>
    }
    @if (multiDownloadRunning) {
        <div class="download-progress flex-item-fixed">
            <span>{{getMultiDownloadProgressText()}}</span>
            <p-progressBar [mode]="multiDownloadProgress?.max > 0 ? 'determinate' : 'indeterminate'" [value]="getMultiDownloadProgressValue()" [showValue]=false></p-progressBar>
        </div>
    }
    @if (!app.isMobile()) {
    <p-splitter class="height100p flex-item-fill flex-row-split height100p overflow-y-auto">
        <ng-template pTemplate>
            <sm-table #tDocuments class="height100p width100p" [data]="table" columnWidthMode="contentFlex" [floatingFilter]=true [useColumnMenu]=false [useTableMenu]=false [(selection)]="selection" (onRowSelect)="rowSelect($event)"
                (onCellClicked)="cellClicked($event)" (onCellValueChanged)="cellEdited($event)"></sm-table>
        </ng-template>
        <ng-template pTemplate>
            <ng-container *ngTemplateOutlet="selectedDocumentTemplate"></ng-container>
        </ng-template>
    </p-splitter>
    }
    @else {
    <sm-table class="flex-item-fill height100p" #tDocuments [data]="table" columnWidthMode="contentFlex" [compact]=true [floatingFilter]=false [useColumnMenu]=false [useTableMenu]=false [(selection)]="selection" (onRowSelect)="rowSelect($event)"
        (onCellClicked)="cellClicked($event)" (onCellValueChanged)="cellEdited($event)"></sm-table>
    }
    }
</div>
@if (app.isMobile() && itemOpened) {
<p-dialog [header]="app.t('documents.details')" class="dialog-maximized documents-mobile-document-dialog" [visible]="app.isMobile() && itemOpened" [modal]=true [baseZIndex]="10000" [draggable]=false [resizable]=false (visibleChange)="closeItemWindow($event)">
    <ng-container *ngTemplateOutlet="selectedDocumentTemplate"></ng-container>
</p-dialog>
}
<ng-template #selectedDocumentTemplate>
    @if (def != null) {
        <enaio-object [showMetaData]="def.showMetaData" [showDocument]="def.hasDocuments" [documentToken]="selectedDocument?.token" [remarkObjects]="remarkObjects" (onTokenExpired)="tokenExpired($event)" (onDocumentLoaded)="documentLoaded($event)"></enaio-object>
    }
</ng-template>
